module.exports = __webpack_public_path__ + "img/science__rabbitv2.a17f8341.svg";